import { useEffect, useRef } from "react";

// Lightweight canvas ember particles drifting upward. No external deps (React 19 safe).
export const EmberCanvas = ({ className = "", density = 60 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let width = (canvas.width = canvas.offsetWidth);
    let height = (canvas.height = canvas.offsetHeight);
    let animationId;

    const colors = ["#FF4500", "#DC2626", "#FFD700", "#FF8C00"];
    const embers = Array.from({ length: density }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      r: Math.random() * 2.4 + 0.6,
      speed: Math.random() * 0.9 + 0.25,
      drift: (Math.random() - 0.5) * 0.5,
      color: colors[Math.floor(Math.random() * colors.length)],
      alpha: Math.random() * 0.6 + 0.2,
      flick: Math.random() * 0.02 + 0.005,
    }));

    const handleResize = () => {
      width = canvas.width = canvas.offsetWidth;
      height = canvas.height = canvas.offsetHeight;
    };
    window.addEventListener("resize", handleResize);

    const render = () => {
      ctx.clearRect(0, 0, width, height);
      embers.forEach((e) => {
        e.y -= e.speed;
        e.x += e.drift;
        e.alpha += (Math.random() - 0.5) * e.flick;
        if (e.alpha < 0.1) e.alpha = 0.1;
        if (e.alpha > 0.85) e.alpha = 0.85;
        if (e.y < -10) {
          e.y = height + 10;
          e.x = Math.random() * width;
        }
        ctx.beginPath();
        ctx.arc(e.x, e.y, e.r, 0, Math.PI * 2);
        ctx.fillStyle = e.color;
        ctx.globalAlpha = e.alpha;
        ctx.shadowBlur = 12;
        ctx.shadowColor = e.color;
        ctx.fill();
      });
      ctx.globalAlpha = 1;
      animationId = requestAnimationFrame(render);
    };
    render();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener("resize", handleResize);
    };
  }, [density]);

  return (
    <canvas
      ref={canvasRef}
      className={`pointer-events-none ${className}`}
      data-testid="ember-canvas"
    />
  );
};
